import { UilEye, UilFileDownload } from '@iconscout/react-unicons';
import { FileDetails, ValidationObj } from '../../../types/interface';
import { useState } from 'react';
import './StandardImageUpload.scss';
import ConditionalRender from 'base/ConditionalRender/ConditionalRender';
import { downloadFileFromUrl, isValidUrl } from 'utils/helpers';
import { DataNotFound } from '../../base/DataNotFound/DataNotFound';
import { t } from 'i18next';
import { ReadMoreModal } from 'components/base/ReadMoreModal';
import { StandardLoader } from 'base/Loader/Loader';
import { COMMON_URLS } from '../../redux/common/commonUrls';

interface StandardImageUploadProps {
  className?: string;
  value: FileDetails;
  disabled?: boolean;
  imageText: string;
  showError?: boolean;
  validations?: ValidationObj[];
  label?: string;
}
export const StandardImageUpload = (props: StandardImageUploadProps) => {
  const [showImageModal, setShowImageModal] = useState(false);
  const [downloadLoader, setDownloadLoader] = useState(false);
  const docsFileMimeTypes = [
    'application/docs',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.template'
  ];
  const excelFileMimeTypes = [
    'application/excel',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.template'
  ];
  const imageMimeTypes = [
    'image/jpeg',
    'image/png',
    'image/gif',
    'image/webp',
    'image/svg+xml',
    'image/bmp',
    'image/tiff',
    'image/x-icon',
    'image/heic',
    'image/heif'
  ];
  const createSource = (file: FileDetails): string | JSX.Element => {
    if (!file) {
      return '';
    }
    if (!isValidUrl(file.file_path)) {
      return <DataNotFound text={t('general.text_1')} />;
    }
    if (
      docsFileMimeTypes.includes(file.mimetype) ||
      excelFileMimeTypes.includes(file.mimetype)
    ) {
      return (
        <iframe
          src={`https://view.officeapps.live.com/op/embed.aspx?src=${file.file_path}`}
          width="100%"
          height="600px"
        ></iframe>
      );
    }
    if (file.mimetype === 'application/pdf' && isValidUrl(file.file_path)) {
      return <embed src={file.file_path} className="w-100 h-100" />;
    }
    if (imageMimeTypes.includes(file.mimetype)) {
      return (
        <img
          src={file.file_path}
          alt={t('general.no_data')}
          className="image-size-cover cover-image"
        />
      );
    }
    return <DataNotFound text={t('general.text_1')} />;
  };

  const handleDownloadFile = () => {
    if (props.value?.file_name) {
      setDownloadLoader(true);
      downloadFileFromUrl({ fileData: props.value, setDownloadLoader });
    }
  };

  const renderImageModal = () => {
    if (showImageModal) {
      return (
        <ReadMoreModal
          closeModal={() => setShowImageModal(false)}
          data={createSource(props.value)}
          headerText={props.imageText}
          className="h-100"
          dataBodyClassName="h-100"
          modalBodyClassName="h-100"
          modalContentClassName="h-100"
        />
      );
    }
  };

  return (
    <>
      <div className={`standard-image-upload ${props.className}`}>
        <ConditionalRender
          condition={!!props.value}
          fallBack={<DataNotFound text={t('general.text_1')} />}
        >
          <div className="d-flex flex-wrap align-items-center h-100 gap-3">
            <ConditionalRender
              condition={!downloadLoader}
              fallBack={
                <div className="w-auto pe-0">
                  <StandardLoader />
                </div>
              }
            >
              <div className="w-auto pe-0">
                <a
                  href={`${process.env.REACT_APP_BASE_URL}${COMMON_URLS.VIEW_FILE}?filename=${props.value?.file_path}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <UilEye
                    // onClick={() => {
                    //   setShowImageModal(true);
                    // }}
                    className="cursor-pointer image-preview text-black"
                  />
                </a>
                <img
                  src={props?.value?.file_path}
                  id="image-upload"
                  style={{ objectFit: 'cover' }}
                  height={'100px'}
                  width={'120px'}
                  className="d-none"
                />
              </div>
              <div className="w-auto pe-0">
                <UilFileDownload
                  onClick={e => {
                    e.preventDefault();
                    handleDownloadFile();
                  }}
                  className="cursor-pointer"
                />
              </div>
            </ConditionalRender>
            <div className="w-auto ps-0">{props.imageText}</div>
          </div>
        </ConditionalRender>
      </div>
      {renderImageModal()}
    </>
  );
};
